import React, { useCallback, useState, FormEvent } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { MdInfo } from 'react-icons/md';
import ReactTooltip from 'react-tooltip';
import * as Yup from 'yup';
import Input from '../../Input/Input';
import Button from '../../Button';
import { useRegister } from '../../../hooks/register';
import { ErrorMessage, SignHeadText } from '../../../styles/globalStyled';
import { DescriptionContent, IconTooltip, SignupModalContainer, BackButton } from '../styles';
import { getErrorMessage } from '../../../utils/validations/errors';

const NameSignUp: React.FC = () => {
  const { handleData, handleStep, userData } = useRegister();
  const [name, setName] = useState(userData?.fullName || '');
  const [error, setError] = useState('');

  const validation = Yup.string()
    .required('Este é um campo obrigatório')
    .test('validName', 'Insira o nome e sobrenome', (value) => (value ? value.trim().split(' ').length > 1 : false));

  const handleChange = (value: string) => {
    setName(value);
    handleData({ fullName: value });
  };

  const onSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      if (validation.isValidSync(name)) {
        setError('');
        handleStep('fillCpf');
      } else {
        const errorMessage = await getErrorMessage(validation, name);
        setError(errorMessage);
      }
    },
    [name],
  );

  return (
    <SignupModalContainer>
      <SignHeadText>
        <label>Por favor, informe seu nome completo</label>
        <DescriptionContent>
          <p>Porque precisamos dessas informações?</p>
          <IconTooltip data-for="cpfTooltip" data-tip="1">
            <MdInfo size={20} />
          </IconTooltip>
          <ReactTooltip
            id="cpfTooltip"
            globalEventOff="click"
            effect="solid"
            delayHide={500}
            place={'bottom'}
            type={'light'}
          >
            Utilizamos o nome apenas para personalização de comunicações da plataforma.
          </ReactTooltip>
        </DescriptionContent>
      </SignHeadText>
      <form onSubmit={onSubmit}>
        <Input
          autoFocus
          name="name"
          type="text"
          placeholder="Nome completo"
          width="full"
          value={name}
          onChangeValue={handleChange}
        />
        <ErrorMessage visibility={error ? 1 : 0}>
          <FiAlertCircle size={20} />
          {error}
        </ErrorMessage>
        <Button title="Continuar" classType="big fat orange center topspace" type="submit" />
        <BackButton onClick={() => handleStep('companySelection')} />
      </form>
    </SignupModalContainer>
  );
};

export default NameSignUp;
